




import { Component, Vue } from 'vue-property-decorator'
import StaffEdit from './edit.vue'

@Component({
  components: {
    StaffEdit
  }
})
export default class StaffDetail extends Vue {
    // 通过props传递isView给编辑组件
    isView = true
}
